<template>
	<el-drawer title="聊天历史记录" size="700px" :visible.sync="visible" direction="rtl" :before-close="onClose">
		<div class="chat-history" v-loading="loading" element-loading-text="拼命加载中">
			<div class="search-box">
				<el-input 
					v-model="searchKeyword" 
					placeholder="搜索历史消息..." 
					prefix-icon="el-icon-search"
					@keyup.enter="searchMessages"
				>
					<template slot="append">
						<el-button @click="searchMessages" type="primary" size="small">搜索</el-button>
					</template>
				</el-input>
				<el-button v-if="showSearchResults" type="info" size="small" @click="resetSearch">清除搜索</el-button>
			</div>
			<el-scrollbar class="scroll-box" ref="scrollbar" id="historyScrollbar">
				<ul>
					<li 
					v-for="(msgInfo, idx) in displayMessages" 
					:key="idx"
					:class="{ 'search-highlight': isSearchResult(msgInfo) }"
					@click="scrollToMessage(msgInfo)"
				>
					<chat-message-item :mode="2" :mine="msgInfo.sendId == mine.id" :headImage="headImage(msgInfo)"
						:showName="showName(msgInfo)" :msgInfo="msgInfo" :menu="false" :searchKeyword="searchKeyword">
					</chat-message-item>
				</li>
				</ul>
			</el-scrollbar>
		</div>
	</el-drawer>
</template>

<script>
import ChatMessageItem from './ChatMessageItem.vue';

export default {
	name: 'chatHistory',
	components: {
		ChatMessageItem
	},
	props: {
		visible: {
			type: Boolean
		},
		chat: {
			type: Object
		},
		friend: {
			type: Object
		},
		group: {
			type: Object
		},
		groupMembers: {
			type: Array,
		}
	},
	data() {
		return {
			page: 1,
			size: 10,
			messages: [],
			searchResults: [],
			searchKeyword: '',
			isSearching: false,
			loadAll: false,
			loading: false,
			lastScrollTime: new Date()
		}
	},
	methods: {
		onClose() {
		this.page = 1;
		this.messages = [];
		this.searchResults = [];
		this.searchKeyword = '';
		this.isSearching = false;
		this.loadAll = false;
		this.$emit('close');
	},
		onScroll() {
			let high = this.$refs.scrollbar.$refs.wrap.scrollTop; //距离顶部的距离
			let timeDiff = new Date().getTime() - this.lastScrollTime.getTime();
			if (high < 30 && timeDiff > 500) {
				this.lastScrollTime = new Date();
				this.loadMessages();

			}
		},
		loadMessages() {
			if (this.loadAll) {
				return this.$message.success("已到达顶部");
			}
			let param = {
				page: this.page++,
				size: this.size
			}
			if (this.chat.type == 'GROUP') {
				param.groupId = this.group.id;
			} else {
				param.friendId = this.friend.id;
			}
			this.loading = true;
			this.$http({
				url: this.histroyAction,
				method: 'get',
				params: param
			}).then(messages => {
				messages.forEach(m => this.messages.unshift(m));
				this.loading = false;
				if (messages.length < this.size) {
					this.loadAll = true;
				}
				this.refreshScrollPos();
			}).catch(() => {
				this.loading = false;
			})
		},
		showName(msgInfo) {
			if (this.chat.type == 'GROUP') {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.showNickName : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.nickName : this.chat.showName
			}
		},
		headImage(msgInfo) {
			if (this.chat.type == 'GROUP') {
				let member = this.groupMembers.find((m) => m.userId == msgInfo.sendId);
				return member ? member.headImage : "";
			} else {
				return msgInfo.sendId == this.mine.id ? this.mine.headImageThumb : this.chat.headImage
			}
		},
		refreshScrollPos() {
			let scrollWrap = this.$refs.scrollbar.$refs.wrap;
			let scrollHeight = scrollWrap.scrollHeight;
			let scrollTop = scrollWrap.scrollTop;
			this.$nextTick(() => {
				let offsetTop = scrollWrap.scrollHeight - scrollHeight;
				scrollWrap.scrollTop = scrollTop + offsetTop;
				// 滚动条没出来，继续加载
				if (scrollWrap.scrollHeight == scrollHeight) {
					this.loadMessages();
				}
			});
		},
		searchMessages() {
			if (!this.searchKeyword.trim()) {
				this.$message.warning('请输入搜索关键词');
				return;
			}
			
			this.loading = true;
			let param = {
				keyword: this.searchKeyword.trim()
			};
			
			if (this.chat.type == 'GROUP') {
				param.groupId = this.group.id;
			} else {
				param.friendId = this.friend.id;
			}
			
			this.$http({
				url: `/message/${this.chat.type.toLowerCase()}/search`,
				method: 'get',
				params: param
			}).then(results => {
				this.searchResults = results;
				this.isSearching = true;
				this.loading = false;
				
				if (results.length === 0) {
					this.$message.info('没有找到相关消息');
				} else {
					this.$message.success(`找到 ${results.length} 条相关消息`);
				}
			}).catch(() => {
				this.loading = false;
				this.$message.error('搜索失败，请重试');
			});
		},
		resetSearch() {
			this.searchResults = [];
			this.searchKeyword = '';
			this.isSearching = false;
		},
		isSearchResult(msgInfo) {
			if (!this.isSearching) return false;
			return this.searchResults.some(result => result.id === msgInfo.id);
		},
		scrollToMessage(msgInfo) {
			// 这里可以实现跳转到聊天窗口对应消息的逻辑
			// 目前先显示消息ID作为示例
			this.$message.info(`消息ID: ${msgInfo.id}`);
			// 可以通过事件通知父组件跳转到对应消息
			this.$emit('jump-to-message', msgInfo);
		}
	},
	computed: {
		mine() {
			return this.userStore.userInfo;
		},
		histroyAction() {
			return `/message/${this.chat.type.toLowerCase()}/history`;
		},
		displayMessages() {
			return this.isSearching ? this.searchResults : this.messages;
		},
		showSearchResults() {
			return this.isSearching && this.searchResults.length > 0;
		}
	},
	watch: {
		visible: {
			handler(newValue, oldValue) {
				if (newValue) {
					this.loadMessages();
					this.$nextTick(() => {
						document.getElementById('historyScrollbar').addEventListener("mousewheel", this.onScroll, true);
					});
				}
			}
		}
	}
}
</script>

<style lang="scss" scoped>
.chat-history {
	display: flex;
	flex-direction: column;
	height: 100%;

	.search-box {
		padding: 15px;
		background-color: #f5f7fa;
		border-bottom: 1px solid #e4e7ed;

		.el-input {
			width: 400px;
			margin-right: 10px;
		}
	}

	.scroll-box {
		flex: 1;

		.el-scrollbar__thumb {
			background-color: #555555;
		}

		ul {
			padding: 20px;

			li {
				list-style-type: none;

				&.search-highlight {
					background-color: #e6f7ff;
					border-radius: 8px;
					padding: 8px;
					margin: 5px 0;
					cursor: pointer;

					&:hover {
						background-color: #bae7ff;
					}
				}
			}
		}
	}
}
</style>
